import { useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import { atom, useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil';

import { useFetchMe } from './useMeStore';

// 初期化済みかどうか
const isAuthInitiatedState = atom<boolean>({
  key: 'AuthStore/isAuthInitiatedState',
  default: false,
});

// 認証済みかどうか
const isAuthorizedState = atom<boolean>({
  key: 'AuthStore/isAuthorizedState',
  default: false,
});

export const useAuthStore = (): [boolean, boolean] => {
  const isAuthInitiated = useRecoilValue(isAuthInitiatedState);
  const isAuthorized = useRecoilValue(isAuthorizedState);
  return [isAuthInitiated, isAuthorized];
};

export const useInitAuth = (): (() => Promise<void>) => {
  const [isAuthInitiated, setIsAuthInitiated] = useRecoilState(isAuthInitiatedState);
  const setIsAuthorized = useSetRecoilState(isAuthorizedState);
  const fetchMe = useFetchMe();

  return useCallback(async () => {
    if (!isAuthInitiated) {
      try {
        await fetchMe();
        setIsAuthorized(true);
      } finally {
        setIsAuthInitiated(true);
      }
    }
  }, [fetchMe, isAuthInitiated, setIsAuthInitiated, setIsAuthorized]);
};

export const useCommitLogin = (): ((token: string) => void) => {
  const setIsAuthorized = useSetRecoilState(isAuthorizedState);

  return useCallback(
    (newToken: string) => {
      localStorage.setItem('token', newToken);
      setIsAuthorized(true);
    },
    [setIsAuthorized]
  );
};

export const useCommitLogout = (): (() => void) => {
  const setIsAuthorized = useSetRecoilState(isAuthorizedState);
  const history = useHistory();

  return useCallback(() => {
    setIsAuthorized(false);
    localStorage.removeItem('token');
    history.push('/login');
  }, [history, setIsAuthorized]);
};
